import React from 'react';
import { Input } from '@this/shared/ui/inputs/input';
import { colors } from '@this/shared/ui/theme/tokens/primitive-tokens/colors';
import { onlineApplicationStyles } from './styles';
import type { ValidationFieldName } from '../shared/validation';

interface ContactFieldsProps {
  contactNameKana: string;
  contactName: string;
  contactEmail: string;
  contactTel: string;
  errors: Record<string, string | undefined>;
  touched: Record<string, boolean>;
  onContactNameKanaChange: (value: string) => void;
  onContactNameChange: (value: string) => void;
  onContactEmailChange: (value: string) => void;
  onContactTelChange: (value: string) => void;
  onBlur: (field: ValidationFieldName) => void;
}

export const ContactFields: React.FC<ContactFieldsProps> = ({
  contactNameKana,
  contactName,
  contactEmail,
  contactTel,
  errors,
  touched,
  onContactNameKanaChange,
  onContactNameChange,
  onContactEmailChange,
  onContactTelChange,
  onBlur
}) => {
  return (
    <>
      <div>
        <span style={onlineApplicationStyles.label.base}>
          担当者名 カナ<span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Input
          value={contactNameKana}
          onChange={e => onContactNameKanaChange(e.target.value)}
          onBlur={() => onBlur('contactNameKana')}
          placeholder="担当者名を入力"
          style={onlineApplicationStyles.form.input.base}
          error={touched.contactNameKana && !!errors.contactNameKana}
        />
        {touched.contactNameKana && errors.contactNameKana && (
          <div style={onlineApplicationStyles.formError.text}>{errors.contactNameKana}</div>
        )}
      </div>
      <div>
        <span style={onlineApplicationStyles.label.base}>
          担当者名 漢字<span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Input
          value={contactName}
          onChange={e => onContactNameChange(e.target.value)}
          onBlur={() => onBlur('contactName')}
          placeholder="担当者名を入力"
          style={onlineApplicationStyles.form.input.base}
          error={!!(touched.contactName && errors.contactName)}
        />
        {touched.contactName && errors.contactName && (
          <div style={onlineApplicationStyles.formError.text}>{errors.contactName}</div>
        )}
      </div>
      <div>
        <span style={onlineApplicationStyles.label.base}>
          担当者 メールアドレス <span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Input
          value={contactEmail}
          onChange={e => onContactEmailChange(e.target.value)}
          onBlur={() => onBlur('contactEmail')}
          placeholder="メールアドレスを入力"
          style={onlineApplicationStyles.form.input.base}
          error={!!(touched.contactEmail && errors.contactEmail)}
        />
        {touched.contactEmail && errors.contactEmail && (
          <div style={onlineApplicationStyles.formError.text}>{errors.contactEmail}</div>
        )}
      </div>
      <div>
        <span style={onlineApplicationStyles.label.base}>
          担当者 電話番号 <span style={{ color: colors.red[500] }}>*</span>
        </span>
        <Input
          value={contactTel}
          onChange={e => onContactTelChange(e.target.value)}
          onBlur={() => onBlur('contactTel')}
          placeholder="電話番号を入力"
          style={onlineApplicationStyles.form.input.base}
          error={!!(touched.contactTel && errors.contactTel)}
        />
        {touched.contactTel && errors.contactTel && (
          <div style={onlineApplicationStyles.formError.text}>{errors.contactTel}</div>
        )}
      </div>
    </>
  );
};
